import { render } from "./OurPartners.vue?vue&type=template&id=07774156&scoped=true"
import script from "./OurPartners.vue?vue&type=script&lang=js"
export * from "./OurPartners.vue?vue&type=script&lang=js"

import "./OurPartners.vue?vue&type=style&index=0&id=07774156&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07774156"]])

export default __exports__